import { createServiceDomains, type Env } from '@bucketplace/config';

type LegacyEnv = Env | 'local';

/**
 * 운영 환경
 * @example local, dev, prod
 */
export const APP_PROFILE = (process.env['APP_PROFILE'] ?? 'local') as LegacyEnv;

/**
 * 앱 이름
 */
export const APP_NAME = 'event-web';

/**
 * 앱 버전
 */
export const APP_VERSION = process.env.APP_VERSION;

export const HOST = process.env.NEXT_PUBLIC_EVENT_HOST as string;

export const ENV: Env =
  APP_PROFILE === 'local'
    ? ((HOST.match(/(dev|qa)/)?.[0] ?? 'dev') as Env)
    : APP_PROFILE;

export const DOMAINS = createServiceDomains({
  env: ENV,
  override: {
    EVENTS: APP_PROFILE === 'local' ? HOST : undefined,
  },
});
